import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

const AuthPage = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  useEffect(() => {
    if (!isAuthenticated) {
      loginWithRedirect();
    }
  }, [loginWithRedirect, isAuthenticated]);
  return <></>;
};

export default AuthPage;
